{
	"title": "Mentions légales",
	"backTitle": "Retour",
	"company": {
		"name": "HDigital GmbH",
		"address": {
			"street": "Berliner Strasse 6",
			"city": "69120 Heidelberg",
			"country": "Allemagne"
		},
		"contact": {
			"telephone": "Téléphone: +49 6221 481-0",
			"telefax": "Télécopie: +49 6221 481-13553",
			"email": "E-mail: info@heidelbergmaterials.com"
		},
		"legal": {
			"registeredOffice": "Siège social de l’entreprise: Heidelberg",
			"commercialRegister": "Registre du commerce: Mannheim, HRB 741878",
			"managingDirectors": "Gérants:",
			"directors": {
				"rene": "René Aldach",
				"roland": "Roland Sterr",
				"noman": "Noman Ahmed"
			}
		}
	}
}
